import React from "react";
import "./ContentSchedule.css";

export default function ContentSchedule() {
  return (
    <div className="content-schedule-container">
      <h1>Content Schedule</h1>
      <h3 className="text-align-center">MONDAY</h3>

      <p>
        <a href="/fantasy/golf">PGA</a> – Gup’s DFS Model Rankings
        <br />
        <a href="/fantasy/golf">PGA</a> – Course Preview Breakdown (course
        preview, event facts, weather)
        <br />
        <a href="/podcasts">PGA</a> – SmashFactor podcast is released on all
        your favorite media platforms
        <br />
        <a href="/betting/nfl">NFL</a>/<a href="/betting/cfb">CFB</a> – 1st look
        bets released
        <br />
        <a href="/fantasy/nfl">NFL</a> - MNF Showstoppers (Showdown Article)
      </p>

      <h3 className="text-align-center">TUESDAY</h3>

      <p>
        <a href="/fantasy/golf">PGA</a> – Course History/Recent Form Deep Dive
        Rankings Released
        <br />
        <a href="/fantasy/golf">PGA</a> – The Triple G MME Article Released
        <br />
        <a href="/betting/golf">PGA</a> – Initial betting card posted
        <br />
        <a href="/fantasy/nfl">NFL</a> – Gup&apos;s NFL Power Rankings
        <br />
        <a href="/fantasy/nfl">NFL</a> – Cup w/ Gup Podcast: Prior week review,
        early look ahead & Power Rankings
      </p>

      <h3 className="text-align-center">WEDNESDAY</h3>

      <p>
        <a href="/betting/golf">PGA</a> – Gup’s Final Betting Card
        <br />
        <a href="/fantasy/golf">PGA</a> – Glorious Nucleus
        <br />
        <a href="/fantasy/golf">PGA</a> – Update to Course Preview posted
        <br />
        <a href="/fantasy/golf">PGA</a> – Gup’s Ownership Projections
        <br />
        <a href="/fantasy/golf">PGA</a> – Gup’s Final Thoughts
        <br />
        <a href="/emergency-9">PGA</a> – Emergency9 Chat – Members only chat
        room (Excludes Fall Events)
        <br />
        <a href="/fantasy/nfl">NFL</a> – DFS Initial Weekly Player Rankings
        &amp; Projections (Latest will be Thursday AM)
      </p>

      <h3 className="text-align-center">THURSDAY</h3>

      <p>
        <a href="/betting/golf">PGA</a> – Gup’s Round 2 Bets
        <br />
        <a href="/fantasy/golf">PGA</a> – Showstoppers (Showdown Article)
        <br />
        <a href="/podcasts">NFL</a> – CoinFlip podcast is released on all your
        favorite media platforms
        <br />
        <a href="/fantasy/nfl">NFL</a> - TNF Showstoppers (Showdown Article)
        <br />
        <a href="/podcasts">CFB</a> – The Read Option DFS & Betting Podcast
        <br />
        <a href="/fantasy/mma">UFC</a> – Corner Advice DFS & Betting Podcast
      </p>

      <h3 className="text-align-center">FRIDAY</h3>

      <p>
        <a href="/betting/golf">PGA</a> – Gup’s Round 3 Bets
        <br />
        <a href="/fantasy/golf">PGA</a> – Showstoppers (Showdown Article)
        <br />
        <a href="/fantasy/nfl">NFL</a> – The Triple G MME Article
        <br />
        <a href="/fantasy/mma">UFC</a> – Weekly Slate Breakdown Article
        <br />
        <a href="/fantasy/cfb">CFB</a> – DFS Main Slate Breakdown Article
        <br />
        <a href="/fantasy/nascar">NAS</a> – Main slate preview article
      </p>

      <h3 className="text-align-center">SATURDAY</h3>

      <p>
        <a href="/betting/golf">PGA</a> – Gup’s Round 4 Bets
        <br />
        <a href="/fantasy/golf">PGA</a> – Showstoppers (Showdown Article)
        <br />
        <a href="/fantasy/nfl">NFL</a> – Gup’s Final Thoughts (Updates as needed
        Sunday AM)
        <br />
        <a href="/fantasy/nascar">NASCAR</a> – Main slate final article &
        updates (after qualifying)
      </p>

      <h3 className="text-align-center">SUNDAY</h3>

      <p>
        <a href="/the-audible">NFL</a> – The Audible Chat – Members only chat
        room, LIVE 11:00am ET on YouTube!
      </p>

      <h3 className="text-align-center">ALL WEEK</h3>

      <p>
        <a href="/fantasy/cfb">CFB</a> - Tuesday-Friday Slates articles as
        applicable
        <br />
        <a href="/fantasy/nba">NBA</a> – DFS Slate Breakdowns &amp; Player Grid
        (Monday-Friday)
        <br />
        Slack Chat open 24/7
      </p>
    </div>
  );
}
